import { PqNavigationController } from "@sabyr-dev/mist_core/controller";
import {
	Attempt, Product, Question, Quiz
} from "@sabyr-dev/mist_elibrary/datasource";
import { AcademyApp } from "../app";
import { PromptEmailEvent } from "../events";

export class AcademyNavigationController extends PqNavigationController<Product, Attempt, Quiz, Question> {
	override switch(app: AcademyApp, previous: number, next: number): Promise<void> {
		if (!app.config.hasEmail && typeof app.config.freeQuestions == 'number' && next >= app.config.freeQuestions) {
			app.current.set(previous);
			app.view.getBindTarget().dispatchEvent(new PromptEmailEvent());
			return super.switch(app, previous, previous);
		} else {
			return super.switch(app, previous, next);
		}
	}
}
